// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/chunks/" + ({"200":"insights","328":"postMetrics","1275":"search-insights","3524":"app"}[chunkId] || chunkId) + "-" + {"200":"819635f1","328":"c3781fb9","1275":"9fdcc939","3524":"be5c69fd","7482":"43f97571"}[chunkId] + ".css";
};